<template>
  <!-- Testimonials -->
      <section class="py-16 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-12">
            <h2 class="text-3xl font-bold text-gray-900 mb-4">ลูกค้าพูดถึงเรา</h2>
            <p class="text-lg text-gray-600">เสียงจากองค์กรที่ใช้ EcobzKM แล้วได้ผลลัพธ์จริง</p>
          </div>

          <div class="grid md:grid-cols-3 gap-8">
            <div class="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow group">
              <div class="flex items-center mb-4">
                <div class="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
                  <span class="text-white font-semibold">T</span>
                </div>
                <div class="ml-3 flex-1">
                  <div class="flex items-center justify-between">
                    <h4 class="font-semibold text-gray-900">Tech Academy Co.</h4>
                    <span class="text-xs text-gray-500 bg-gray-200 px-2 py-1 rounded-full">ยืนยันแล้ว ✓</span>
                  </div>
                  <p class="text-sm text-gray-600">CTO - คุณสุรชัย วิทยากร</p>
                  <p class="text-xs text-gray-500">ใช้งานมา 2 ปี • โรงเรียนสอนโปรแกรมมิง</p>
                </div>
              </div>
              <p class="text-gray-600 italic mb-3">"EcobzKM ช่วยลดเวลาพัฒนาระบบจาก 6 เดือน เหลือ 2 สัปดาห์ API ครบ ใช้งานง่าย ประหยัดงบไปกว่า 3 ล้านบาท"</p>
              <div class="flex items-center justify-between">
                <div class="flex text-yellow-400">
                  <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                  <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                  <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                  <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                  <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                  <span class="ml-2 text-sm text-gray-600 font-medium">5.0</span>
                </div>
                <span class="text-xs text-gray-500">รีวิวเมื่อ 3 เดือนที่แล้ว</span>
              </div>
            </div>

            <div class="bg-gray-50 rounded-xl p-6">
              <div class="flex items-center mb-4">
                <div class="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center">
                  <span class="text-white font-semibold">E</span>
                </div>
                <div class="ml-3">
                  <h4 class="font-semibold text-gray-900">EduCorp Thailand</h4>
                  <p class="text-sm text-gray-600">CEO - อรัญญา เรียนรู้</p>
                </div>
              </div>
              <p class="text-gray-600 italic">"ระบบหลายเทนแนนต์ทำให้เราบริการลูกค้าหลายรายพร้อมกัน รายงานละเอียด ช่วยตัดสินใจทางธุรกิจได้ดีขึ้น"</p>
              <div class="flex text-yellow-400 mt-3">
                <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
              </div>
            </div>

            <div class="bg-gray-50 rounded-xl p-6">
              <div class="flex items-center mb-4">
                <div class="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                  <span class="text-white font-semibold">S</span>
                </div>
                <div class="ml-3">
                  <h4 class="font-semibold text-gray-900">StartupEd Hub</h4>
                  <p class="text-sm text-gray-600">Founder - ศิวิไล นวัตกรรม</p>
                </div>
              </div>
              <p class="text-gray-600 italic">"ฟีเจอร์ White Label ช่วยให้เราทำแบรนด์ของเราเอง ลูกค้าใช้งานภายใต้แบรนด์เรา และ ROI เพิ่มขึ้น 300%"</p>
              <div class="flex text-yellow-400 mt-3">
                <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- FAQ Section -->
      <section class="py-16 bg-gray-50">
        <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-12">
            <h2 class="text-3xl font-bold text-gray-900 mb-4">คำถามที่พบบ่อย</h2>
            <p class="text-lg text-gray-600">รวมคำตอบสำหรับคำถามที่ลูกค้าถามบ่อย</p>
          </div>

          <div class="space-y-4">
            <!-- FAQ Item 1 -->
            <div class="bg-white rounded-lg shadow-sm border border-gray-200">
              <button 
                @click="toggleFaq(0)"
                class="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
              >
                <span class="font-semibold text-gray-900">ติดตั้งระบบใช้เวลานานแค่ไหน?</span>
                <svg 
                  class="w-5 h-5 text-gray-500 transform transition-transform duration-200" 
                  :class="{ 'rotate-180': openFaqs[0] }"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              <div 
                v-show="openFaqs[0]" 
                class="px-6 pb-4 text-gray-600 transition-all duration-200"
              >
                ระบบสามารถติดตั้งและเริ่มใช้งานได้ภายใน 24 ชั่วโมง รวมถึงการย้ายข้อมูลและปรับแต่งตามความต้องการของคุณ
              </div>
            </div>

            <!-- FAQ Item 2 -->
            <div class="bg-white rounded-lg shadow-sm border border-gray-200">
              <button 
                @click="toggleFaq(1)"
                class="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
              >
                <span class="font-semibold text-gray-900">รองรับผู้ใช้พร้อมกันได้กี่คน?</span>
                <svg 
                  class="w-5 h-5 text-gray-500 transform transition-transform duration-200" 
                  :class="{ 'rotate-180': openFaqs[1] }"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              <div 
                v-show="openFaqs[1]" 
                class="px-6 pb-4 text-gray-600 transition-all duration-200"
              >
                ระบบรองรับผู้ใช้งานได้ไม่จำกัด โดยมีแพ็กเกจตั้งแต่ 100 คนไปจนถึงไม่จำกัด พร้อมการกระจายโหลด (Load Balancing) เพื่อความเสถียร
              </div>
            </div>

            <!-- FAQ Item 3 -->
            <div class="bg-white rounded-lg shadow-sm border border-gray-200">
              <button 
                @click="toggleFaq(2)"
                class="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
              >
                <span class="font-semibold text-gray-900">เชื่อมต่อกับระบบที่มีอยู่เดิมได้หรือไม่?</span>
                <svg 
                  class="w-5 h-5 text-gray-500 transform transition-transform duration-200" 
                  :class="{ 'rotate-180': openFaqs[2] }"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              <div 
                v-show="openFaqs[2]" 
                class="px-6 pb-4 text-gray-600 transition-all duration-200"
              >
                ได้ ระบบมี API ครบ รองรับ RESTful และ GraphQL พร้อม Webhooks สำหรับเชื่อมต่อกับระบบ HR, CRM หรือระบบอื่น ๆ
              </div>
            </div>

            <!-- FAQ Item 4 -->
            <div class="bg-white rounded-lg shadow-sm border border-gray-200">
              <button 
                @click="toggleFaq(3)"
                class="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
              >
                <span class="font-semibold text-gray-900">มีมาตรการความปลอดภัยของข้อมูลหรือไม่?</span>
                <svg 
                  class="w-5 h-5 text-gray-500 transform transition-transform duration-200" 
                  :class="{ 'rotate-180': openFaqs[3] }"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              <div 
                v-show="openFaqs[3]" 
                class="px-6 pb-4 text-gray-600 transition-all duration-200"
              >
                มีมาตรฐาน ISO 27001, ใบรับรอง SSL, การเข้ารหัสข้อมูล และการสำรองข้อมูลอัตโนมัติทุก 6 ชั่วโมง
              </div>
            </div>

            <!-- FAQ Item 5 -->
            <div class="bg-white rounded-lg shadow-sm border border-gray-200">
              <button 
                @click="toggleFaq(4)"
                class="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
              >
                <span class="font-semibold text-gray-900">ยกเลิกการใช้บริการได้ตลอดเวลาหรือไม่?</span>
                <svg 
                  class="w-5 h-5 text-gray-500 transform transition-transform duration-200" 
                  :class="{ 'rotate-180': openFaqs[4] }"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              <div 
                v-show="openFaqs[4]" 
                class="px-6 pb-4 text-gray-600 transition-all duration-200"
              >
                ได้ ไม่มีข้อผูกมัดระยะยาว คุณสามารถยกเลิกได้ตลอดเวลา และเราจะส่งข้อมูลทั้งหมดให้ในรูปแบบที่นำไปใช้ต่อได้
              </div>
            </div>
          </div>

          <!-- Ask More Questions Button -->
          <div class="text-center mt-8">
            <button 
              @click="openQuestionModal"
              class="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
              ถามคำถามเพิ่มเติม
            </button>
          </div>
        </div>
      </section>

      <!-- Question Modal -->
      <div 
        v-if="showQuestionModal" 
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
        @click.self="closeQuestionModal"
      >
        <div class="bg-white rounded-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <!-- Modal Header -->
          <div class="flex justify-between items-center p-6 border-b">
            <h3 class="text-xl font-bold text-gray-900">ถามคำถามเพิ่มเติม</h3>
            <button 
              @click="closeQuestionModal"
              class="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>

          <!-- Modal Body -->
          <div class="p-6">
            <p class="text-gray-600 mb-6">กรุณากรอกข้อมูลด้านล่าง เราจะติดต่อกลับภายใน 24 ชั่วโมง</p>
            
            <form @submit.prevent="submitQuestion" class="space-y-4">
              <!-- Name Field -->
              <div>
                <label for="name" class="block text-sm font-medium text-gray-700 mb-2">
                  ชื่อ-นามสกุล *
                </label>
                <input 
                  v-model="questionForm.name"
                  type="text" 
                  id="name"
                  required
                  class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="กรุณากรอกชื่อ-นามสกุล"
                />
              </div>

              <!-- Email Field -->
              <div>
                <label for="email" class="block text-sm font-medium text-gray-700 mb-2">
                  อีเมล *
                </label>
                <input 
                  v-model="questionForm.email"
                  type="email" 
                  id="email"
                  required
                  class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="example@email.com"
                />
              </div>

              <!-- Question Field -->
              <div>
                <label for="question" class="block text-sm font-medium text-gray-700 mb-2">
                  คำถาม *
                </label>
                <textarea 
                  v-model="questionForm.question"
                  id="question"
                  required
                  rows="4"
                  class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                  placeholder="กรุณาระบุคำถามที่ต้องการสอบถาม..."
                ></textarea>
              </div>

              <!-- Submit Buttons -->
              <div class="flex gap-3 pt-4">
                <button
                  type="button"
                  @click="closeQuestionModal"
                  class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  ยกเลิก
                </button>
                <button
                  type="submit"
                  class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  ส่งคำถาม
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
</template>

<script setup>
import { ref } from 'vue'

// Reactive state for FAQ accordion (first item always open)
const openFaqs = ref([true, false, false, false, false])

// Modal state
const showQuestionModal = ref(false)
const questionForm = ref({
  name: '',
  email: '',
  question: ''
})

// Toggle FAQ item
const toggleFaq = (index) => {
  openFaqs.value[index] = !openFaqs.value[index]
}

// Modal functions
const openQuestionModal = () => {
  showQuestionModal.value = true
}

const closeQuestionModal = () => {
  showQuestionModal.value = false
  // Reset form
  questionForm.value = {
    name: '',
    email: '',
    question: ''
  }
}

const submitQuestion = () => {
  // Here you can add your API call to submit the question
  console.log('Submitting question:', questionForm.value)
  
  // For now, just show an alert and close modal
  alert('ขอบคุณสำหรับคำถาม เราจะติดต่อกลับภายใน 24 ชั่วโมง')
  closeQuestionModal()
}
</script>

<style scoped>
/* Any component-specific styles can be added here */
</style>
